import React, { useState } from 'react';
import { Card, Col, Form, Row, Select, Switch, Typography } from 'antd';

const { Text } = Typography;

export interface DailyKpiHistoryConfig {
    chartType: 'line' | 'bar';
    showParent: boolean;
    showChildren: boolean;
}

const DEFAULT_CONFIG: DailyKpiHistoryConfig = {
    chartType: 'line',
    showParent: true,
    showChildren: false,
};

interface Props {
    initialConfig?: Partial<DailyKpiHistoryConfig>;
    onChange: (config: DailyKpiHistoryConfig) => void;
}

const sanitizeScope = (config: DailyKpiHistoryConfig): DailyKpiHistoryConfig => {
    if (config.showParent || config.showChildren) return config;
    return { ...config, showParent: true };
};

export const SectionConfigDailyKpiHistory: React.FC<Props> = ({ initialConfig, onChange }) => {
    const [config, setConfig] = useState<DailyKpiHistoryConfig>(
        sanitizeScope({
            ...DEFAULT_CONFIG,
            ...initialConfig,
        })
    );

    const updateField = <K extends keyof DailyKpiHistoryConfig>(field: K, value: DailyKpiHistoryConfig[K]) => {
        const next = sanitizeScope({ ...config, [field]: value });
        setConfig(next);
        onChange(next);
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Row gutter={12}>
                <Col xs={24} md={8}>
                    <Form.Item label="Chart type">
                        <Select
                            value={config.chartType}
                            onChange={(value: 'line' | 'bar') => updateField('chartType', value)}
                            options={[
                                { label: 'Line', value: 'line' },
                                { label: 'Bar', value: 'bar' },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xs={12} md={8}>
                    <Form.Item label="Show parent (aggregated)">
                        <Switch
                            checked={config.showParent}
                            onChange={(checked) => updateField('showParent', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col xs={12} md={8}>
                    <Form.Item label="Show children breakdown">
                        <Switch
                            checked={config.showChildren}
                            onChange={(checked) => updateField('showChildren', checked)}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Text type="secondary" style={{ fontSize: 12 }}>
                Daily bucket is fixed. Missing days are shown as gaps.
            </Text>
        </Card>
    );
};

export default SectionConfigDailyKpiHistory;
